import script from "./Recrutment.vue?vue&type=script&setup=true&lang=js"
export * from "./Recrutment.vue?vue&type=script&setup=true&lang=js"

import "./Recrutment.vue?vue&type=style&index=0&id=7c2b1e77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c2b1e77"]])

export default __exports__